import { formatToastDiagnosticCode } from './sheet-load-trace.util';

/**
 * The sentence shown when a signed-in user opens a PAGE their role may not see
 * (today: a non-Admin typing the User Management URL).
 *
 * Deliberately a different sentence from `LOAD_FAILURE_COPY.PERM`
 * ("You don't have access to this record."), which is for a filing that does not
 * belong to the user. The two scenarios branch on WHAT was refused:
 *
 * | Refused thing | Sentence | Where the user lands |
 * |---|---|---|
 * | A filing (conversion) that is not theirs | `LOAD_FAILURE_COPY.PERM` | previous page, else XBRL Files |
 * | A page their role cannot see | this constant | Dashboard, always |
 */
export const PAGE_ACCESS_DENIED_COPY = "You don't have permission to access this page.";

/**
 * The full toast line: the sentence followed by the bare `MBRS-PERM` code, the
 * same shape every other PERM toast has.
 *
 * Whether this toast is shown at all is decided by the caller
 * (`AccessDeniedNoticeService`) from `refactoredDiagnosticCodesEnabled`: with the
 * flag off, a refused page redirects WITHOUT a toast, which is what every
 * page-level load failure did before the diagnostics existed.
 */
export function buildPageAccessDeniedSummary(): string {
  return `${PAGE_ACCESS_DENIED_COPY} ${formatToastDiagnosticCode('PAGE', 'PERM', null)}`;
}
